import { ReactElement } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

export function DepartmentSkeleton(): ReactElement {
  return (
    <>
      <Skeleton
        className={styles.title}
        variant='line'
        width={92}
        height={22}
      />
      <div className={styles.departmentWidget}>
        <div className={styles.widgetHeader}>
          <Skeleton className={styles.widgetTitle} variant='title' />
        </div>

        <div>
          <Skeleton className={styles.department} variant='title' />

          <div className={styles.manager}>
            <Skeleton className={styles.managerBlockTitle} />

            <div className={styles.managerInfoWrapper}>
              <div className={styles.managerColumn}>
                <Skeleton variant='square' />
              </div>

              <div className={styles.managerColumn}>
                <div className={styles.managerInfo}>
                  <Skeleton className={styles.managerName} width={220} />

                  <Skeleton className={styles.managerName} width={120} />

                  <Skeleton className={styles.managerPost} width={130} />
                  <Skeleton className={styles.managerPost} width={150} />
                </div>
              </div>
            </div>

            <Skeleton className={styles.managerBlockTitle} />

            <div className={styles.managerInfoWrapper}>
              <div className={styles.managerColumn}>
                <Skeleton variant='square' />
              </div>

              <div className={styles.managerColumn}>
                <div className={styles.managerInfo}>
                  <Skeleton className={styles.managerName} width={250} />

                  <Skeleton className={styles.managerName} width={150} />

                  <Skeleton className={styles.managerPost} width={180} />
                  <Skeleton className={styles.managerPost} width={100} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
